import CryptoJS from 'crypto-js';
import axios from 'axios';
import { btoa, atob } from '../../lib/helpers';
import { dataIntervalRefund } from '../params';
import { postApi } from '../../lib/fetcher';

const refundInternal = {
  namespaced: true,

  state() {
    return {
      allData: [],
      totalData: 0,
      loading: false,
      loadingAcquirer: false,
      loadingIssuer: false,
      cacheData: {},
      errors: [],
      flashErrorMessage: '',
      flashError: false,
      item: null,
      insertProgress: 0,
      downloadFailedURL: '',
      countDone: 0,
      countSame: 0,
      intervalExport: null,
      exportId: null,
      countDataExport: 0,
      allAcquirer: null,
      allIssuer: null,
      totalPage: 0,

      requestData: null,
      percentage: 0,
      refundStatus: false,
      countSameRefund: 0,
      countDoneRefund: 0,
      refundId: null,
      countDataRefund: 0,
    };
  },

  mutations: {
    setData(state, { payload }) {
      state.allData = payload.data.list;
    },

    setItem(state, { payload }) {
      state.item = payload.data.data;
    },

    setCategory(state, data) {
      state.allCategory = data;
    },

    setFlashErrorMessage(state, payload) {
      state.flashErrorMessage = payload;
      state.flashError = payload != '';
    },

    clearData(state) {
      state.allData = [];
      state.totalData = 0;
    },

    clearErrors(state) {
      state.errors = [];
    },

    setErrors(state, payload) {
      state.errors = payload;
    },

    setTotalData(state, { payload }) {
      state.totalData = parseInt(payload.data.countdata, 10);
      state.totalPage = parseInt(payload.data.totalPage, 10);
    },

    setLoading(state, loading) {
      state.loading = loading;
    },

    setLoadingAcquirer(state, loadingAcquirer) {
      state.loadingAcquirer = loadingAcquirer;
    },

    setLoadingIssuer(state, loadingIssuer) {
      state.loadingIssuer = loadingIssuer;
    },

    setInsertProgress(state, insertProgress) {
      state.insertProgress = insertProgress;
    },

    setIntervalExport(state, payload) {
      state.intervalExport = payload;
    },

    setExportData(state, payload) {
      state.exportId = payload.export_id;
      state.countDataExport = payload.count_data;
    },

    setAcquirer(state, payload) {
      state.allAcquirer = payload;
    },

    setIssuer(state, payload) {
      state.allIssuer = payload;
    },

    setStateVariable(state, { payload, variable }) {
      state[variable] = payload;
    },

    setCancelation(state, payload) {
      state.requestData = payload;
    },

    removeData(state, { index }) {
      state.totalData -= 1;
      state.allData = state.allData.filter((value) => value.id != index);
    },

    setIntervalRefund(state, payload) {
      state.intervalRefund = payload;
    },

    setRefundData(state, payload) {
      state.refundId = payload.export_id;
      state.countDataRefund = parseInt(payload.count_data, 10);
    },
  },

  actions: {
    async getData(ctx, { date, page, itemsPerPage, sortBy, sortDesc, search }) {
      if (ctx.state.requestData) ctx.state.requestData.cancel();

      const axiosSource = axios.CancelToken.source();
      ctx.commit('setCancelation', {
        cancel: axiosSource.cancel,
        msg: 'Loading...',
      });

      ctx.commit('clearData');
      ctx.commit('setLoading', true);
      const sort = !sortDesc[0] ? 'ASC' : 'DESC';
      const sort_by = `${sortBy[0] ? sortBy[0] : 'rrn'} ${sort}`;

      if (search.trx_datetime.length == 2) {
        const d1 = Date.parse(search.trx_datetime[0]);
        const d2 = Date.parse(search.trx_datetime[1]);

        if (d1 > d2) {
          const temp = search.trx_datetime[1];
          // eslint-disable-next-line prefer-destructuring, no-param-reassign
          search.trx_datetime[1] = search.trx_datetime[0];
          // eslint-disable-next-line no-param-reassign
          search.trx_datetime[0] = temp;
        }
      }

      const data = JSON.stringify({
        page: page.toString(),
        limit: itemsPerPage.toString(),
        search,
        sort_by,
        version: btoa(
          CryptoJS.SHA256(
            page.toString() +
              itemsPerPage.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
      const urlApi = `/index.php?r=api/v1/refund_internal/refund/index`;

      const addConfig = { cancelToken: axiosSource.token };

      const responseData = await postApi(ctx, urlApi, data, addConfig);

      if (responseData?.code == 200) {
        ctx.commit('setTotalData', { payload: responseData });
        ctx.commit('setData', { payload: responseData });
      }
    },

    async getAcquirer(ctx, { date }) {
      ctx.commit('setLoadingAcquirer', true);

      try {
        const data = JSON.stringify({
          version: btoa(
            CryptoJS.SHA256(
              date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
            ).toString()
          ),
        });

        const urlApi = `/index.php?r=api/v1/report/merchant-transaction/acquirer`;

        const responseData = await postApi(ctx, urlApi, data);

        if (responseData?.code == 200) {
          ctx.commit('setAcquirer', responseData.data);
        }
      } finally {
        ctx.commit('setLoadingAcquirer', false);
      }
    },

    async getIssuer(ctx, { date }) {
      ctx.commit('setLoadingIssuer', true);

      try {
        const data = JSON.stringify({
          version: btoa(
            CryptoJS.SHA256(
              date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
            ).toString()
          ),
        });

        const urlApi = `/index.php?r=api/v1/report/merchant-transaction/issuer`;

        const responseData = await postApi(ctx, urlApi, data);

        if (responseData?.code == 200) {
          ctx.commit('setIssuer', responseData.data);
        }
      } finally {
        ctx.commit('setLoadingIssuer', false);
      }
    },

    async refundData(ctx, { date, id, index }) {
      ctx.commit('setLoading', true);
      const data = JSON.stringify({
        id,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/refund_internal/refund/refund`;

      const responseData = await postApi(ctx, urlApi, data);

      let resVal = false;
      if (responseData?.code == 200) {
        console.log(index);
        resVal = true;
      }
      return resVal;
    },

    async bulkRefund(ctx, { date, id, options, search }) {
      if (ctx.state.refundStatus) {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Refund Done !',
            icon: 'mdi-check-circle',
            color: 'green',
          },
          { root: true }
        );
        return;
      }
      ctx.commit('setLoading', true);
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'percentage',
      });
      ctx.commit('setStateVariable', {
        payload: true,
        variable: 'refundStatus',
      });
      ctx.commit('setStateVariable', {
        payload: 0,
        variable: 'countSameRefund',
      });

      const data = JSON.stringify({
        id,
        search,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Refund Done !',
            icon: 'mdi-check-circle',
            color: 'green',
          },
          { root: true }
        );
        ctx.commit('setStateVariable', {
          payload: false,
          variable: 'refundStatus',
        });
      };

      const urlApi = `/index.php?r=api/v1/refund_internal/refund/refund-checked`;

      const responseData = await postApi(ctx, urlApi, data);

      try {
        if (responseData?.code == 200) {
          if (responseData.data.message != null) {
            ctx.commit(
              'setSnackbar',
              {
                status: true,
                message: 'Refund Done !',
                icon: 'mdi-check-circle',
                color: 'green',
              },
              { root: true }
            );
            ctx.commit('setStateVariable', {
              payload: false,
              variable: 'refundStatus',
            });
            return;
          }
          ctx.commit('setRefundData', responseData.data);
          const interval = setInterval(() => {
            ctx.dispatch('refundStatus', {
              date,
              options,
              search,
            });
          }, dataIntervalRefund);
          ctx.commit('setIntervalRefund', interval);
        } else {
          failed();
        }
      } catch (error) {
        failed();
      }
    },

    async refundStatus(ctx, { date, options, search }) {
      const data = JSON.stringify({
        export_id: ctx.state.refundId,
        count_data: ctx.state.countDataRefund,
        version: btoa(
          CryptoJS.SHA256(
            ctx.state.refundId.toString() +
              ctx.state.countDataRefund.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const failed = () => {
        clearInterval(ctx.state.intervalRefund);
        ctx.commit(
          'setSnackbar',
          {
            status: true,
            message: 'Refund Done !',
            icon: 'mdi-check-circle',
            color: 'green',
          },
          { root: true }
        );
        ctx.commit('setStateVariable', {
          payload: false,
          variable: 'refundStatus',
        });
      };

      try {
        const urlApi = `/index.php?r=api/v1/refund_internal/refund/status-checked`;
        const responseData = await postApi(ctx, urlApi, data);
        if (responseData.code == '10') {
          clearInterval(ctx.state.intervalRefund);
          ctx.commit('setStateVariable', {
            payload: 100,
            variable: 'percentage',
          });
          ctx.commit(
            'setSnackbar',
            {
              status: true,
              message: 'Refund Done !',
              icon: 'mdi-check-circle',
              color: 'green',
            },
            { root: true }
          );
          ctx.commit('setStateVariable', {
            payload: false,
            variable: 'refundStatus',
          });
          ctx.dispatch('getData', {
            date,
            page: options.page,
            itemsPerPage: options.itemsPerPage,
            sortBy: options.sortBy,
            sortDesc: options.sortDesc,
            search,
          });
        } else if (responseData.code == '302') {
          failed();
        } else {
          const totalDataDone = parseInt(responseData.data.count_success, 10);
          ctx.commit('setStateVariable', {
            payload: (totalDataDone / ctx.state.countDataRefund) * 100,
            variable: 'percentage',
          });
          if (ctx.state.countDoneRefund != totalDataDone) {
            ctx.commit('setStateVariable', {
              payload: totalDataDone,
              variable: 'countDoneRefund',
            });
            ctx.commit('setStateVariable', {
              payload: 0,
              variable: 'countSameRefund',
            });
          } else {
            ctx.commit('setStateVariable', {
              payload: ctx.state.countSameRefund + 1,
              variable: 'countSameRefund',
            });
          }
          if (ctx.state.countSameRefund > 2) {
            failed();
          }
        }
      } catch (error) {
        failed();
      }
    },
  },
};
export default refundInternal;
